// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-section {
  background-color: var(--color-bg-card);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 15px;
}

.filter-section label {
  font-weight: 500;
  color: var(--color-text-light);
}

.filter-section select {
  padding: 8px 12px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  min-width: 250px;
  background-color: var(--color-bg-card);
  color: var(--color-text-light);
}

.filter-label {
  font-weight: 500;
  color: var(--color-text-light);
}

/* Active / Archived / All. Built on the app's pill shape so it sits naturally
   next to the status badges it filters. */
.view-toggle {
  display: flex;
  gap: 6px;
}

.view-pill {
  padding: 5px 14px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background-color: transparent;
  color: var(--color-text-muted);
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.view-pill:hover {
  background-color: var(--color-bg-hover);
  color: var(--color-text-light);
}

.view-pill.is-selected {
  background-color: var(--wylie-purple);
  border-color: var(--wylie-purple);
  color: var(--wylie-white);
}

/* Shown when a terminal status is selected, to explain why archived candidates
   are in the results despite the Show toggle. */
.filter-hint {
  color: var(--color-text-muted);
  font-size: 12px;
  font-style: italic;
}

/* Archived rows recede without disappearing. */
.candidate-table tr.is-archived td {
  color: var(--color-text-muted);
}

/* Not the terminal statuses: a candidate in one is always archived, so fading
   them would mean Rejected / Offer Declined / Recruited never show their colour
   (opal Rejected read as grey). */
.candidate-table tr.is-archived .status-badge:not(.status-archived):not(.status-rejected):not(.status-offer_declined):not(.status-recruited) {
  opacity: 0.65;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CandidateList.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;0CAC0C;AAC1C;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;gDACgD;AAChD;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,8BAA8B;AAChC;;AAEA;;kCAEkC;AAClC;EACE,aAAa;AACf","sourcesContent":[".filter-section {\n  background-color: var(--color-bg-card);\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.filter-section label {\n  font-weight: 500;\n  color: var(--color-text-light);\n}\n\n.filter-section select {\n  padding: 8px 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  min-width: 250px;\n  background-color: var(--color-bg-card);\n  color: var(--color-text-light);\n}\n\n.filter-label {\n  font-weight: 500;\n  color: var(--color-text-light);\n}\n\n/* Active / Archived / All. Built on the app's pill shape so it sits naturally\n   next to the status badges it filters. */\n.view-toggle {\n  display: flex;\n  gap: 6px;\n}\n\n.view-pill {\n  padding: 5px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background-color: transparent;\n  color: var(--color-text-muted);\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.view-pill:hover {\n  background-color: var(--color-bg-hover);\n  color: var(--color-text-light);\n}\n\n.view-pill.is-selected {\n  background-color: var(--wylie-purple);\n  border-color: var(--wylie-purple);\n  color: var(--wylie-white);\n}\n\n/* Shown when a terminal status is selected, to explain why archived candidates\n   are in the results despite the Show toggle. */\n.filter-hint {\n  color: var(--color-text-muted);\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Archived rows recede without disappearing. */\n.candidate-table tr.is-archived td {\n  color: var(--color-text-muted);\n}\n\n/* Not the terminal statuses: a candidate in one is always archived, so fading\n   them would mean Rejected / Offer Declined / Recruited never show their colour\n   (opal Rejected read as grey). */\n.candidate-table tr.is-archived .status-badge:not(.status-archived):not(.status-rejected):not(.status-offer_declined):not(.status-recruited) {\n  opacity: 0.65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
